import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class GraphEdgeLookupData {
    graphEdges: Array<DropdownOptionIntegerId>;
    sourceVertices: Array<DropdownOptionIntegerId>;
    targetVertices: Array<DropdownOptionIntegerId>;
}
